import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FaChevronLeft} from 'react-icons/fa';
import './BackToResults.css';


interface BackToResultsProps {
    overlay?: boolean;
}

const BackToResults: React.FC<BackToResultsProps> = ({ overlay }) => {
    const location = useLocation();
    const fromSearch = (location.state as { fromSearch?: string })?.fromSearch;

    if (!fromSearch) {
        return null;
    }

    return (
        <div className={`back-to-results-container ${overlay ? 'back-to-results-overlay' : ''}`}>
            <Link to={fromSearch} className='back-to-results-button'>
                <FaChevronLeft size={14} />
                Back to results
            </Link>
        </div>
    );
};

export default BackToResults;
